<template>
  <v-radio-group v-model = "active"
    :label="label"
    :mandatory="false"
    @change="$emit('input', $event)"    
    hide-details
    >
      <v-layout column>
       <v-flex style="display:flex" v-for="(item, index) in items" :key="index" align-top pa-1>
        <v-checkbox 
        hide-details multiple :input-value = "active" :value="item[itemValue] || Object.values(item)[0]" @change="onChange" class="shrink mt-0 mr-2"
        :disabled="item[itemDisabled]"></v-checkbox>
        <component :is="createComp(item[itemText] || Object.values(item)[0])"/>
       </v-flex>
     </v-layout>
  </v-radio-group>
</template>

<script>
  import formats from '../../api/formats.js'
  export default {
    name: 'v-select-check',
    props: {
      label: null,
      value: null,
      itemText: {
        type: String,
        default: 'text'
      },
      itemValue: {
        type: String,
        default: 'value'
      },
      itemDisabled: {
        type: String,
        default: 'disabled'
      },
      items: Array,
      default () {
        return []
      }
    },
    data: function () {
      return {
        active: null
      }
    },
    created () {
    },
    mounted () {
      this.active = this.parse(this.value)
    },
    watch: {
      value: function (newValue) {
        this.active = this.parse(newValue)
      }
    },
    computed: {
    },
    methods: {
      createComp (template) {
        return formats.createComp(`<span>${template}</span>`)
      },
      parse (v) {
        if (Array.isArray(v)) {
          return v
        } else {
          return v && v.split(', ') || []
        }
      },
      onChange (e) {
        this.$emit('input', e.join(', '))
      }
    }

  }
</script>



// WEBPACK FOOTER //
// SelectCheck.vue?dea00812